import { render, staticRenderFns } from "./AttachmentDialog.vue?vue&type=template&id=481e39c4&scoped=true&"
import script from "./AttachmentDialog.vue?vue&type=script&lang=ts&"
export * from "./AttachmentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentDialog.vue?vue&type=style&index=0&id=481e39c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e39c4",
  null
  
)

export default component.exports